









import Vue from 'vue';

export default Vue.extend({
    name: 'SpecialAccessInput',
    props: {
        value: {
            type: String,
            required: true,
        },
    },
});
